import { defineMessages } from 'react-intl'

const messages = defineMessages({
  dataSource: {
    id: 'ReportTable.dataSource',
    description: 'Fuente',
    defaultMessage: 'Fuente'
  },
  dataNote: {
    id: 'ReportTable.dataNote',
    description: 'Nota',
    defaultMessage: 'Nota'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Charts/ReportTableRow/ReportTableRowContainer/messages.js